import { Injectable } from '@angular/core';
import * as SockJS from 'sockjs-client';
import { UserService } from 'src/app/main/pages/services/user.service';
import { environment } from 'src/environments/environment.test';
import * as Stomp from 'webstomp-client';

@Injectable({ providedIn: 'root' })
export class WebsocketService {
  private stompClient: Stomp.Client;

  constructor(private _userService: UserService) {
    this.stompClient = new Stomp.Client();
  }

  connect(): void {
    if (this.stompClient && this.stompClient.connected) {
      return;
    }

    let url = `${environment.WEBSOCKET_URL}websocket/notifications`;
    const token = this._userService.getToken();
    if (token) {
      url += `?access_token=${token}`;
    }
    try {
      const socket: WebSocket = new SockJS(url);
      this.stompClient = Stomp.over(socket);
      const headers: Stomp.ConnectionHeaders = {};
      this.stompClient.connect(headers, () => {});
    } catch (error) {
      console.error(error);
    }
  }

  getClient(): any {
    return this.stompClient;
  }

  send(room: string, data: any, headers: any = {}): void {
    this.stompClient.send(room, JSON.stringify(data), headers);
  }

  disconnect(): void {
    if (this.stompClient) {
      if (this.stompClient.connected) {
        this.stompClient.disconnect();
      }
      this.stompClient;
    }
  }
}
